import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ClaimProductState,
} from '@savgroup-front-common/types';

interface SetClaimAdditionalInformationArgs {
  claimId: string;
  additionalClaimInformationValues: { id: string; value: string }[];
}

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/additionalInformation`;

const setClaimAdditionalInformation = async ({
  claimId,
  additionalClaimInformationValues,
}: SetClaimAdditionalInformationArgs): Promise<
  BackResponse<ClaimProductState> | BackResponseFailure
> => {
  if (!claimId) {
    throw new Error(
      'Could not call setClaimAdditionalInformation without a claimId.',
    );
  }
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId);

    const response = await apiCall<BackResponse<ClaimProductState>>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        additionalClaimInformation: additionalClaimInformationValues,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default setClaimAdditionalInformation;
